import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()((theme) => ({
  item: {
    ...dFlex('initial', 'center'),
    gap: 4,
  },
  withPadding: {
    paddingLeft: 16,
  },
  comingSoon: {
    opacity: 0.4,
  },
  icon: {
    svg: {
      path: {
        fill: theme.primary.p3,
      },
    },
  },
  blueIcon: {
    svg: {
      path: {
        fill: 'none',
      },
    },
  },
  label: {
    backgroundColor: theme.accent.a1,
    border: `1px solid ${theme.accent.a1}`,
    borderRadius: 4,
    padding: '1.5px 8px',
    whiteSpace: 'nowrap',
  },
}));

export default useStyles;
